import React from "react";
import services from "../../../services";
import $ from "jquery";
import TitleBar from "../../../components/common/title_bar";
import { withRouter } from "react-router-dom";
import SearchFilter from "../../../components/filters/SearchFilter";
import SelosTables from "./SelosTable";
import ApprovedRejected from "./sealPopUp/ApprovedRejected";
import PendingSuspended from "./sealPopUp/PendingSuspended";
import AffixingPopUp from "./AffixingPopup/Popup";
import GraphicasTabMain from "./graphicasPopup/GraphicasTabMain"; //*********** */
import Destruction from "./graphicasPopup/Destruction";
import SidePopup from "./SidePopup";
import DropDownCellGraficas from './myDropDownCellGraficas';
import CurrencyInput from 'react-currency-input-field';
import Swal from "sweetalert2";

const filters = {
    Tabs: {
        NIF: [
            {
                key: "nif",
                displayKey: "procurar por nif",
                inputType: "text",
            },
        ]
    },
    checkbox: [],
}

class SelosEmCobranca extends React.Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selosPopup: "",
            filter: this.props.linkData.filters,
            popUpForm: "",
            popUpForm2: null,
            processPopUpForm: null,
            imagePopUp: "",
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: [],
            },
            billing_address: null,
            applyedfilter: {
                //  entity_id: this.props.parsed.entity_id
            },
            checkedInvoice: [],
            general_balance_row: "",
            date: new Date(),
            recentGenInvoicePopUp: "",
            handlenext: false,
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createState();
        $(window).scrollTop(0);
        // this.getCurrentGeneralAccount();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            $(window).scrollTop(0);
            this.createState();
        }
    }
     handleChange = (e) => {
        if(e.currentTarget.value.includes("-")){

        }else{
            if (this.props.onChange) {
                this.props.onChange({
                dataIndex: 0,
                dataItem: this.props.dataItem,
                field: this.props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.value
              });
            }
        }
        
      };
    /* Para criar o estado básico da página no carregamento */

    createState = () => {
        this.setState({
            entity_details: {},
            applyedfilter: {},
            filters: this.props.linkData.filters,
        });
    };
    /* Para obter dados filtrados do componente de filtro personalizado  */
    preventNegativeValues = (e) => ["e", "E", "+", "-" , ","].includes(e.key) && e.preventDefault()
    handleFilter = (data) => {
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    };
    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        let applyedfilter = {
            ...customfilters.filterCheckbox,
            ...customfilters.filters,
        };
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem("Local");
        console.log("filter", applyedfilter);
        this.setState({
            applyedfilter,
            date: new Date(),
        });
    };

    Graphicas = (action, row) => {
        let selosPopup = (
            <GraphicasTabMain date={new Date()} row={row} action={action} />
        );
        this.setState({
            selosPopup,
        });
        console.log("changed next", this.state.handlenext);
    };
    testDestruction = (action, row) => {
        let selosPopup = <Destruction date={new Date()} />;
        this.setState({
            selosPopup,
        });
        console.log("changed next", this.state.handlenext);
    };

    affixingPopup = (action, row) => {
        let selosPopup = <AffixingPopUp action={action} row={row} />;
        this.setState({
            selosPopup,
        });
    };

    selosApprovedPopup = (action, row) => {
        let handlenext = this.state.handlenext;
        console.log("changed prev", handlenext);

        let selosPopup = (
            //%%%%%%%%%%%%%%%%%%%%%%%%%%%uncomment this
            <ApprovedRejected
                pedidos={action}
                handledef={handlenext}
                row={row}
            />
            // <AffixingPopUp/>
        );
        this.setState({
            selosPopup,
            handlenext: !handlenext,
        });
        console.log("changed next", this.state.handlenext);
    };
    selosPendingPopup = (action, row) => {
        let handlenext = this.state.handlenext;

        let selosPopup = (
            <PendingSuspended
                date={Date.now()}
                pedidos={action}
                handledef={handlenext}
                row={row}
            />
        );
        this.setState({
            selosPopup,
            handlenext: !handlenext,
        });
    };

    closePopup = () => {
        $(".left-popup").trigger('click');
        window.location.reload();
    }
    
    sidePopup = (menu, submenu, row) => {
        let header = {
            menu, 
            submenu
        }

        let selosPopup = (
            <SidePopup
                date={Date.now()}
                header={header}
                row={row}
                closePopup={this.closePopup}
            />
        );
        this.setState({
            selosPopup,
        });
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        let menu = action.menu
        let submenu = action.submenu
        console.log("777000 menu ", menu, submenu, row)
        this.sidePopup(menu, submenu, row)
    };

    /*  Para renderizar o conteúdo html da página   */

    AddNewgrafica = () => {

        
            if($("#GraficaSelect :selected").val() === "0" || $("#Quantidade").val() === "" || $("#Quantidade").val() === "0"){
                Swal.fire({
                    icon: 'error',
                    title: 'Campos de preenchimento obrigatório',
                  })
            }else{
                const num1 = 100000;
                //const num3 =10000000;
                const num2 = parseFloat($("#Quantidade").val().replace(/\./g, '').replace(/\./g, '.'))

                const remainder = num2 % num1 ;
                //const remainder2 = num3 % num2;
                console.log(remainder); 

                if (remainder === 0) {
                    Swal.fire({
                        title: 'Deseja atribuir os selos?',
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonText: 'Sim',
                        denyButtonText: 'Não',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            (async () => {
                            var data = $("#id-form-new-grafica").serialize();
                            data = {
                                idEntidadeGrafica: parseInt($('#GraficaSelect :selected').val()),
                                quantidade: parseFloat($("#Quantidade").val().replace(/\./g, '').replace(/\./g, '.')),
                                LoggedUser: window.localStorage.getItem('username'),
                                idEntidade: parseInt($('#GraficaSelect :selected').val()),
                            }
                            let grafica = await services.apiCall.requestApi(
                                "/Selos/GerarNumeracaoSelosGarantia",
                                data,
                                "post"
                            );
                            if (grafica) {
                                $('#id-form-new-grafica')[0].reset();
                                $('#id-cancel-new-grafica').trigger('click');
                            }
                            })();
                        } else if (result.isDenied) {
                            
                        }
                    })


                    
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Introduza uma quantidade múltipla de 100.000 até ao limite de 10 milhões.',
                    })
                }
                
            }
            

        

    }

    render() {

        //console.log("Tablename",this.props.linkData.tableName);
        return (
            <div className="inner-container">
                <a
                    className="hidden"
                    id="processPopUp"
                    data-toggle="modal"
                    data-target="#process-pending"
                ></a>
               
                <div className="outer-space">
                    <TitleBar
                        path={this.props.linkData.tableName === 'SelosPendentes' || this.props.linkData.tableName == 'SelosTodosPedidos' ? this.props.linkData.TitleBarpath : this.props.location.pathname}
                        title={this.props.linkData.TitleBartitle}
                        logo={"selos"}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        changeOption={(mainIndex, subIndex) =>
                            this.props.changeOption(mainIndex, subIndex)
                        }
                        optionMenuArray={this.props.optionMenuArray}
                    />
                    {this.props.linkData.tableName === 'SelosRastreabilidade' ? 
                        (
                            <SearchFilter
                                searchplaceholder="Pesquisa por Número de Selo"
                                installationNumberTest={true}
                                
                                filters={filters}
                                moduleType="SelosRastreabilidade"
                                data={this.state.data}
                                handleFilter={(data) => this.handleFilter(data)}
                                getFilter={(data) => this.getFilters(data)}
                            />
                        )
                        : this.props.linkData.tableName === 'SelosRequisiçãoPendentes' ? this.props.linkData.filters &&
                            Object.keys(this.props.linkData.filters).length > 0 && (
                                <SearchFilter
                                    searchplaceholder="Pesquisa por NIF ou designação"
                                    installationNumber={true}
                                    
                                    filters={filters}
                                    moduleType="SelosRequisiçãoPendentes"
                                    data={this.state.data}
                                    handleFilter={(data) => this.handleFilter(data)}
                                    getFilter={(data) => this.getFilters(data)}
                                />
                            )
                        : this.props.linkData.filters &&
                            Object.keys(this.props.linkData.filters).length > 0 && (
                                <SearchFilter
                                    searchplaceholder="Pesquisa por NIF ou designação"
                                    installationNumber={true}
                                    filters={filters}
                                    moduleType="Conta"
                                    data={this.state.data}
                                    handleFilter={(data) => this.handleFilter(data)}
                                    getFilter={(data) => this.getFilters(data)}
                                />
                            )
                    }
                    {
                        <SelosTables
                            date={this.state.date}
                            tableName={this.props.linkData.tableName}
                            applyedfilter={this.state.applyedfilter}
                            ActionPerform={(action, row) =>
                                this.ActionPerform(action, row)
                            }
                        />
                    }
                </div>
                {
                    <div className="modal fade" id="process-pending">
                        <div className="modal-dialog modal-dialog-centered">
                            {this.state.processPopUpForm}
                        </div>
                    </div>
                }
                {
                    <div className="modal fade" id="popup-image-preview">
                        <div className="modal-dialog modal-dialog-centered">
                            {this.state.imagePopUp}
                        </div>
                    </div>
                }
                {
                    <div className="modal left-popup" id="selos-popup">
                        <div className="modal-dialog modal-sm">
                            {this.state.selosPopup}
                        </div>
                    </div>
                }
                {
                    <div className="modal left-popup" id="selos-graficas-popup">
                        <div className="modal-dialog modal-sm">
                            <div class="modal-content" style={{maxWidth: "571px"}}>
                                <div class="modal-header" style={{fontSize: "20px"}}>
                                    <h5 class="modal-title">Atribuir Selos</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form id="id-form-new-grafica">
                                        <DropDownCellGraficas/>
                                        
                                        <div className="col-md-12">
                                            <div className="input-box active-grey drop-down-box">
                                                <label className="input-label">
                                                    Quantidade
                                                </label>
                                                <CurrencyInput
                                                    id='Quantidade'
                                                    name="quantidade"
                                                    defaultValue={0.000}
                                                    decimalSeparator="," 
                                                    groupSeparator="."
                                                    maxLength={8}
                                                    precision="3"
                                                    className="input-1 Quantidade blockSpecialChar"
                                                    // intlConfig={{ style: 'currency' ,locale: 'pt-PT', currency: 'EUR' }}
                                                    min="0"
                                                    onValueChange={(value, name) => console.log(value, name)}
                                                    onChange={this.handleChange} 
                                                    onKeyDown={this.preventNegativeValues}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="modal-footer">
                                    <button id="id-add-new-grafica" type="button" class="btn btn-primary" style={{backgroundColor : "#960030" , border: "1px solid #960030"}} onClick={this.AddNewgrafica}>Submeter</button>
                                    <button id="id-cancel-new-grafica" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                                </div>
                            </div>

                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(SelosEmCobranca);
